import '@theme/variant-picker';

class TrialSubscriptionPicker extends HTMLElement {
  connectedCallback() {
    this.abortController = new AbortController();
    const { signal } = this.abortController;
    this.addEventListener('change', () => this.syncPurchase(), { signal });
    this.addEventListener('variant:update', () => this.syncPurchase(), { signal });
    const initialize = () => {
      if (!this.isConnected) return;
      const form = document.getElementById(this.dataset.formId);
      form?.addEventListener('submit', (event) => {
        const selected = this.querySelector('input[type="radio"]:checked');
        if (!selected || selected.disabled) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
        this.syncPurchase();
      }, { capture: true, signal });
      const variantId = new URLSearchParams(window.location.search).get('variant');
      const selected = Array.from(this.querySelectorAll('input[type="radio"]'))
        .find((input) => input.dataset.variantId === variantId) || this.querySelector('input[type="radio"]:checked');
      selected?.dispatchEvent(new Event('change', { bubbles: true }));
      this.syncPurchase();
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialize, { once: true, signal });
    } else {
      initialize();
    }
  }

  disconnectedCallback() {
    this.abortController?.abort();
  }

  syncPurchase() {
    const selected = this.querySelector('input[type="radio"]:checked');
    const card = selected?.closest('[data-purchase-type]');
    const planId = card?.dataset.sellingPlanId || '';
    const planInput = this.querySelector('[data-trial-selling-plan]');
    planInput.value = planId;
    planInput.disabled = !planId || Boolean(selected?.disabled);
    const form = document.getElementById(this.dataset.formId);
    const variantInput = form?.querySelector('input[name="id"]');
    const available = Boolean(selected && !selected.disabled);
    if (variantInput) {
      variantInput.value = selected?.dataset.variantId || '';
      variantInput.disabled = !available;
    }
    const button = form?.querySelector('[ref="addToCartButton"]');
    if (button) {
      button.disabled = !available;
      const text = button.querySelector('.add-to-cart-text__content');
      if (text) text.textContent = available ? this.dataset.addToCartText : this.dataset.soldOutText;
      const icon = button.querySelector('.add-to-cart-icon');
      if (icon) icon.hidden = !available;
    }
    form?.querySelector('[ref="acceleratedCheckoutButtonContainer"]')?.toggleAttribute('hidden', !available);
    if (card && this.selectedVariantId !== selected?.dataset.variantId) {
      this.selectedVariantId = selected?.dataset.variantId;
      const quantity = form?.querySelector('quantity-selector-component');
      quantity?.updateConstraints?.(card.dataset.quantityMin, card.dataset.quantityMax || null, card.dataset.quantityStep);
      if (card.dataset.mediaSrc) {
        form?.querySelector('add-to-cart-component')?.setAttribute('data-product-variant-media', card.dataset.mediaSrc);
      }
      if (card.dataset.mediaId) {
        const gallery = this.closest('.shopify-section')?.querySelector('media-gallery');
        const slides = Array.from(gallery?.querySelectorAll('slideshow-slide') || []);
        const index = slides.findIndex((slide) => slide.querySelector(`[data-media-id="${card.dataset.mediaId}"]`));
        if (index >= 0) gallery.slideshow?.select(index, undefined, { animate: false });
      }
    }
    this.closest('.product-details')?.querySelectorAll('.option-subscription-text').forEach((note) => {
      note.hidden = !planId;
    });
  }
}

if (!customElements.get('trial-subscription-picker')) {
  customElements.define('trial-subscription-picker', TrialSubscriptionPicker);
}
